import React from 'react';
import Toggle from './Toggle';

/**
 * Исключительно визуальный компонент переключателя для карточек блюд.
 * Все события клика должны обрабатываться родительской карточкой.
 */
const DishToggle = ({
  checked = false,
  disabled = false,
  className = ''
}) => {
  return (
    <div className={`dish-toggle-wrapper pointer-events-none ${className}`}>
      <Toggle
        checked={checked}
        onChange={() => {}} // Игнорируем внутренние изменения
        disabled={disabled}
        size="md"
      />
    </div>
  );
};

export default DishToggle;